import React from 'react'

import './Featured.scss'

function Featured() {
  return (
    <div className="featured-items">
      <div className="featured-item-wrapper">
        <div className="featured-spacer"></div>
        <h3 className="featured-headline _1">
          Police consider themselves above the law.
        </h3>
        <h3 className="featured-headline _2">
          Another headline goes here at some point.
        </h3>
        <h3 className="featured-headline _3">
          Yet another headline goes here sometime soon.
        </h3>
        <div
          data-w-id="2b525644-605f-8585-cca2-fd3b838ade7b"
          className="featured-content-double-wrapper"
        >
          <div className="featured-content-wrapper">
            <p>
              An Aurora PD officer (Meier) who passed out drunk <em>while</em>
               driving <br />
            </p>
            <ul className="list">
              <li className="list-item">
                kept his job
                <a
                  href="https://www.denverpost.com/2019/12/11/aurora-police-officer-drunk-driving/#:~:text=An%20on%2Dduty%2C%20armed%20and,18th%20Judicial%20District%20Attorney%27s%20Office.&amp;text=The%20actions%20of%20Officer%20Nathan,Meier%20could%20warrant%20criminal%20charges."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="superscript"
                >
                  3
                </a>
                <br />
              </li>
              <li>
                wasn&#x27;t charged
                <a
                  href="https://www.denverpost.com/2019/12/11/aurora-police-officer-drunk-driving/#:~:text=An%20on%2Dduty%2C%20armed%20and,18th%20Judicial%20District%20Attorney%27s%20Office.&amp;text=The%20actions%20of%20Officer%20Nathan,Meier%20could%20warrant%20criminal%20charges."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="superscript"
                >
                  3
                </a>
              </li>
            </ul>
            <p>
              The officers who found Meier passed out deemed that no test was
              required
              <a href="#" className="superscript">
                4
              </a>
              <br />
              Meier admitted to going home and drinking vodka on his shift
              <a
                href="https://kool1079.com/aurora-police-officer-found-drunk-in-patrol-car-keeps-job-no-dui/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                4,
              </a>{' '}
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
              Meier&#x27;s BAC was .220, nearly three times the legal limit
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
              Meier&#x27;s punishment is losing around $9,000 due to a demotion,
              and not being permitted to apply for a higher rank until 2021
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
            </p>
            <p>
              In a separate incident, another Aurora PD officer, Brook, is
              arrested while off duty and charged with DUI and careless driving,
              but charges are dismissed by the DA
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
              She was involved in a single-car crash, hitting a concrete highway
              barrier
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
              Brook&#x27;s BAC was 0.227
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
            </p>
          </div>
        </div>
        <div
          data-w-id="2b525644-605f-8585-cca2-fd3b838adeae"
          className="featured-content-double-wrapper"
        >
          <div className="featured-content-wrapper">
            <p>
              An Aurora PD officer (Meier) who passed out drunk <em>while</em>
               driving <br />
            </p>
            <ul className="list">
              <li className="list-item">
                kept his job
                <a
                  href="https://www.denverpost.com/2019/12/11/aurora-police-officer-drunk-driving/#:~:text=An%20on%2Dduty%2C%20armed%20and,18th%20Judicial%20District%20Attorney%27s%20Office.&amp;text=The%20actions%20of%20Officer%20Nathan,Meier%20could%20warrant%20criminal%20charges."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="superscript"
                >
                  3
                </a>
                <br />
              </li>
              <li>
                wasn&#x27;t charged
                <a
                  href="https://www.denverpost.com/2019/12/11/aurora-police-officer-drunk-driving/#:~:text=An%20on%2Dduty%2C%20armed%20and,18th%20Judicial%20District%20Attorney%27s%20Office.&amp;text=The%20actions%20of%20Officer%20Nathan,Meier%20could%20warrant%20criminal%20charges."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="superscript"
                >
                  3
                </a>
              </li>
            </ul>
            <p>
              The officers who found Meier passed out deemed that no test was
              required
              <a href="#" className="superscript">
                4
              </a>
              <br />
              Meier admitted to going home and drinking vodka on his shift
              <a
                href="https://kool1079.com/aurora-police-officer-found-drunk-in-patrol-car-keeps-job-no-dui/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                4,
              </a>{' '}
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
              Meier&#x27;s BAC was .220, nearly three times the legal limit
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
              Meier&#x27;s punishment is losing around $9,000 due to a demotion,
              and not being permitted to apply for a higher rank until 2021
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
            </p>
            <p>
              In a separate incident, another Aurora PD officer, Brook, is
              arrested while off duty and charged with DUI and careless driving,
              but charges are dismissed by the DA
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
              She was involved in a single-car crash, hitting a concrete highway
              barrier
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
              Brook&#x27;s BAC was 0.227
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
            </p>
          </div>
        </div>
        <div
          data-w-id="2b525644-605f-8585-cca2-fd3b838adee1"
          className="featured-content-double-wrapper"
        >
          <div className="featured-content-wrapper">
            <p>
              An Aurora PD officer (Meier) who passed out drunk <em>while</em>
               driving <br />
            </p>
            <ul className="list">
              <li className="list-item">
                kept his job
                <a
                  href="https://www.denverpost.com/2019/12/11/aurora-police-officer-drunk-driving/#:~:text=An%20on%2Dduty%2C%20armed%20and,18th%20Judicial%20District%20Attorney%27s%20Office.&amp;text=The%20actions%20of%20Officer%20Nathan,Meier%20could%20warrant%20criminal%20charges."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="superscript"
                >
                  3
                </a>
                <br />
              </li>
              <li>
                wasn&#x27;t charged
                <a
                  href="https://www.denverpost.com/2019/12/11/aurora-police-officer-drunk-driving/#:~:text=An%20on%2Dduty%2C%20armed%20and,18th%20Judicial%20District%20Attorney%27s%20Office.&amp;text=The%20actions%20of%20Officer%20Nathan,Meier%20could%20warrant%20criminal%20charges."
                  target="_blank"
                  rel="noopener noreferrer"
                  className="superscript"
                >
                  3
                </a>
              </li>
            </ul>
            <p>
              The officers who found Meier passed out deemed that no test was
              required
              <a href="#" className="superscript">
                4
              </a>
              <br />
              Meier admitted to going home and drinking vodka on his shift
              <a
                href="https://kool1079.com/aurora-police-officer-found-drunk-in-patrol-car-keeps-job-no-dui/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                4,
              </a>{' '}
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
              Meier&#x27;s BAC was .220, nearly three times the legal limit
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
              Meier&#x27;s punishment is losing around $9,000 due to a demotion,
              and not being permitted to apply for a higher rank until 2021
              <a
                href="https://kdvr.com/news/local/demoted-aurora-officer-loses-11k-during-suspension-public-still-fuming-over-drunk-driving/"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                5
              </a>
              <br />
            </p>
            <p>
              In a separate incident, another Aurora PD officer, Brook, is
              arrested while off duty and charged with DUI and careless driving,
              but charges are dismissed by the DA
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
              She was involved in a single-car crash, hitting a concrete highway
              barrier
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
              Brook&#x27;s BAC was 0.227
              <a
                href="https://www.thedenverchannel.com/news/local-news/aurora-police-officer-pleads-guilty-to-dui-having-weapon-while-drunk"
                target="_blank"
                rel="noopener noreferrer"
                className="superscript"
              >
                6
              </a>
              <br />
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Featured
